// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2SADY","buttons":"RemoveExpirationActionButtons_buttons__fvPQJ"};